import React from 'react';

import HomePageBanner from './HomePageBanner';
import { BannerData } from './HomePageBanner/models';

export interface HomePageBannerPropsRaw {
  'desktop-background-img'?: { url: string };
  'mobile-background-img'?: { url: string };
  'heading-title'?: string;
  'heading-sub-title'?: string;
  'description-short'?: string;
  'button-title'?: string;
  'button-link'?: string;
  disclaimer?: string;
  'overlay-image'?: { url: string };
}

const HomePageBannerWrapper = (props: HomePageBannerPropsRaw) => {
  const {
    'desktop-background-img': backgroundImage,
    'mobile-background-img': backgroundImageMobile,
    'heading-title': headingTitle,
    'heading-sub-title': headingSubTitle,
    'description-short': descriptionShort,
    'button-title': buttonTitle,
    'button-link': buttonLink,
    disclaimer,
    'overlay-image': overlayImage,
  } = props;

  const data: BannerData = {
    backgroundImage,
    backgroundImageMobile,
    headingTitle,
    headingSubTitle,
    descriptionShort,
    buttonTitle,
    buttonLink,
    disclaimer,
    overlayImage,
  };

  return <HomePageBanner data={data} />;
};

HomePageBannerWrapper.displayName = 'HomePageBannerWrapper';
export default HomePageBannerWrapper;
